import { Entity } from './Entity.js';
export class EntityCache {
    constructor({ initial, ctx }) {
        this.cache = new Map();
        this.get = (init) => {
            const cached = this.getCached(init.oid);
            if (cached)
                return cached;
            const entity = new Entity(init);
            this.cache.set(init.oid, this.ctx.weakRef(entity));
            return entity;
        };
        this.has = (oid) => {
            return this.cache.has(oid);
        };
        this.getCached = (oid) => {
            if (this.cache.has(oid)) {
                const ref = this.cache.get(oid);
                const derefed = ref === null || ref === void 0 ? void 0 : ref.deref();
                if (derefed) {
                    return derefed;
                }
                else {
                    this.cache.delete(oid);
                }
            }
            return null;
        };
        this.ctx = ctx;
        if (initial) {
            for (const entity of initial) {
                this.cache.set(entity.oid, ctx.weakRef(entity));
            }
        }
    }
}
//# sourceMappingURL=EntityCache.js.map